import React, { Component } from 'react';

class Loader extends Component {
    render() {
        return (
            <div className='loader-container' id='loadingBar'><span className="loader" ></span></div>
        );
    }
}

export default Loader;